module.exports = __webpack_public_path__ + "static/img/ico_user_relation.cf2bf31.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/ico_user_relation.png
// module id = 52rO
// module chunks = 1